export const FETCH_ADMIN_USER_NEW_REQUEST = "FETCH_ADMIN_USER_NEW_REQUEST";
export const FETCH_ADMIN_USER_NEW_SUCCESS = "FETCH_ADMIN_USER_NEW_SUCCESS";
export const FETCH_ADMIN_USER_NEW_FAILURE = "FETCH_ADMIN_USER_NEW_FAILURE";